import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext(null);

const LOCALES = ["de", "en", "es"];

export const LanguageProvider = ({ children }) => {
  const initial = (typeof window !== "undefined" && localStorage.getItem("locale")) || "de";
  const [locale, setLocaleState] = useState(LOCALES.includes(initial) ? initial : "de");

  const setLocale = useCallback((l) => {
    if (!LOCALES.includes(l)) return;
    setLocaleState(l);
    try {
      localStorage.setItem("locale", l);
    } catch {
      /* ignore */
    }
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[locale] || translations.de;
      return dict[key] ?? translations.de[key] ?? key;
    },
    [locale]
  );

  const value = useMemo(() => ({ locale, setLocale, t, locales: LOCALES }), [locale, setLocale, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be inside LanguageProvider");
  return ctx;
};
